module.exports = __webpack_public_path__ + "img/2_220.94f8fc3a.png";